import { render, staticRenderFns } from "./deletedRealEstates.vue?vue&type=template&id=ae5e7730&scoped=true&"
import script from "./deletedRealEstates.vue?vue&type=script&lang=js&"
export * from "./deletedRealEstates.vue?vue&type=script&lang=js&"
import style0 from "./deletedRealEstates.vue?vue&type=style&index=0&id=ae5e7730&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae5e7730",
  null
  
)

export default component.exports